import ApiResourceManager from '../ApiResourceManager';

export default class ManagersManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/managers',
      params,
    });

  getBusinessManagers = (params) =>
    this.request({
      method: 'GET',
      url: '/business-managers',
      params,
    });

  createBusinessManagers = (data) =>
    this.request({
      method: 'POST',
      url: '/business-managers',
      data,
    });

  updateBusinessManagers = (managerId, data) =>
    this.request({
      method: 'PATCH',
      url: `/business-managers/${managerId}`,
      data,
    });

  deleteBusinessManagers = (id, params) =>
    this.request({
      method: 'DELETE',
      url: `/business-managers/${id}`,
      params,
    });

  // Mails the owner a new password. 429 with `error_code` owner_invite_resend_cooling_down right after a resend.
  resendOwnerInvite = (managerId) =>
    this.request({
      method: 'POST',
      url: `/business-managers/${managerId}/resend-invite`,
    });

  // Changes or removes a restaurant's owner (PROD-637). Body: see services/team/changeOwner.js buildChangeOwnerPayload.
  changeCompanyOwner = (data) =>
    this.request({
      method: 'PUT',
      url: '/business-managers/owner',
      data,
    });

  // Owner of the company in the x-on-behalf-of-company header, or null.
  getCompanyOwner = () =>
    this.request({
      method: 'GET',
      url: '/company/owner',
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/managers',
      data,
    });

  partialUpdate = (id, data) =>
    this.request({
      method: 'PATCH',
      url: `/managers/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/managers/${id}`,
    });

  getGlobalAccessControlList = (params) =>
    this.request({
      method: 'GET',
      url: '/global-access-control-list',
      params,
    });

  updateGlobalAccessControlList = (data) =>
    this.request({
      method: 'PUT',
      url: '/global-access-control-list',
      data,
    });
}
